module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGZpbGw9IiNGRkI5NTMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDBjOC4yODQgMCAxNSA2LjcxNiAxNSAxNSAwIDguMjg0LTYuNzE2IDE1LTE1IDE1LTguMjg0IDAtMTUtNi43MTYtMTUtMTVDMCA2LjcxNiA2LjcxNiAwIDE1IDB6bTAgOGMtMy44NjYgMC03IDMuMTM0LTcgNyAwIDEuOTA4Ljc2NCAzLjYzOSAyLjAwMiA0LjkwMUw4IDIyaDdsLjI0LS4wMDRDMTguOTk2IDIxLjg2OSAyMiAxOC43ODYgMjIgMTVjMC0zLjg2Ni0zLjEzNC03LTctN3oiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/chat-icon.svg
// module id = PneU
// module chunks = 6